/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.create.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.validate',
  'acme.common.service.helpers',
  'acme.common.factory.wizard',
  'acme.common.directive.viewMenu'
])

.controller('ResourcesCreateController', ['$scope', '$state', '$log', 'ApiService', 'ValidateService', 'HelpersService', 'WizardFactory', function($scope, $state, $log, ApiService, ValidateService, HelpersService, WizardFactory) {

    $scope.resourcesCreate = {

      templateId: -1,

      wizard: {},

      menu: [
        {
          id: 'setup',
          name: 'Basic Setup',
          info: 'Describe your template',
          selected: true,
          isValid: function() {
            return !$scope.resourcesCreate.wizard.invalidCheck();
          },
          action: function() {
            $scope.$emit('resourcesCreate::setup');
          }
        },
        {
          id: 'customize',
          name: 'Customize',
          info: 'Customize your template',
          action: function() {
            $scope.$emit('resourcesCreate::customize');
          }
        }
      ],

      tmp: {
        fields: [],
        categories: [
          'Personnel',
          'Facilities',
          'Equipment'
        ]
      },

      entityType: {},

      selectedResourceCategory: 'Personnel',

      model: {
        name: '',
        description: '',
        resourceCategory: 'Personnel'
      },

      init: function() {

        if ($state.params.hasOwnProperty('id')) {
          this.templateId = $state.params.id;
          this.getTemplate(this.templateId);
        }

        if ($state.params && $state.params.type) {
          this.entityType = HelpersService.getEntityName($state.params.type);
          this.selectedResourceCategory = HelpersService.cap(this.entityType.plural);
        }

        $scope.$emit('Application::contentTitleChange', {
          title: 'Create Resource Template'
        });

        $scope.$on('resourceFieldCreate::save', this.onResourceFieldCreateSave);
        $scope.$on('resourceFieldCreate::save::success', this.success.onResourceFieldCreateSave);
        $scope.$on('resourceFieldCreate::save::success', this.error.onResourceFieldCreateSave);

        $scope.$on('resourceFieldDetail::remove', this.onResourceFieldDetailRemove);
        $scope.$on('resourceFieldEdit::remove', this.onResourceFieldDetailRemove);

        $scope.$on('resourceFieldCreate::cancel', this.onResourceFieldCreateCancel);

        $scope.$on('resourcesCreate::setup', function() {
          $scope.resourcesCreate.wizard.setCurrentStep('setup');
        });

        $scope.$on('resourcesCreate::customize', function() {
          $scope.resourcesCreate.wizard.setCurrentStep('customize');
        });

        this.wizard = new WizardFactory();
        this.wizard.init([
          {
            name: 'setup',
            validators: [
              {
                field: 'resources-create-name',
                len: {
                  message: 'Your type must not be empty',
                  test: function() {
                    return {
                      value: $scope.resourcesCreate.model.name
                    };
                  }
                }
              },
              {
                field: 'resources-create-description',
                len: {
                  message: 'Your description must not be empty',
                  test: function() {
                    return {
                      value: $scope.resourcesCreate.model.description
                    };
                  }
                }
              }
            ]
          },
          { name: 'customize' }
        ]);
        this.addField();
      },

      complete: function() {
        var i, ii;

        if (ValidateService.validate([
          { len: { value: this.model.name } },
          { len: { value: this.model.description } }
        ])) {
          $scope.$broadcast('ResourcesCreateController::complete', {
            callback: function() {
              $scope.resourcesCreate.model.resourceCategory = $scope.resourcesCreate.selectedResourceCategory;
              ApiService.resource.update($scope.resourcesCreate.model, $scope.resourcesCreate.templateId).then($scope.resourcesCreate.success.complete, $scope.resourcesCreate.error.complete);
            }
          });
        }else{
          // Do nothing
        }
      },

      save: function() {
        if (ValidateService.validate([
          { len: { value: this.model.name } },
          { len: { value: this.model.description } }
        ])) {
          this.model.resourceCategory = this.selectedResourceCategory;
          ApiService.resource.create(this.model).then(this.success.save, this.error.save);
        }else{
          // Do nothing
        }
      },

      updateWizardStep: function(method, save) {
        var i, ii;

        this.wizard[method]();

        for (i=0,ii=this.menu.length;i<ii;i++) {
          this.menu[i].selected = (this.menu[i].id === this.wizard.getStepName());
        }

        if (save) {
          this.save();
        }

        if (method === 'done') {
          this.complete();
        }
      },

      addField: function() {
        this.tmp.fields.push({
          fieldOrder: 0,
          name: "",
          type: "StringType",
          stringValue: null,
          stringArrayValue: null,
          numberValue: null,
          numberArrayValue: null,
          minValue: 0,
          maxValue: 1,
          hidden: false
        });
      },

      hasModelFields: function() {
        return (this.model.fields && this.model.fields.length > 0);
      },

      success: {
        complete: function(response, status, headers, config) {
          $scope.$emit('ResourcesCreateController::success');
          $state.go('application.entities.templates', { type: $scope.resourcesCreate.selectedResourceCategory.toLowerCase() });
        },

        save: function(response, status, headers, config) {
          $scope.resourcesCreate.templateId = response.data.id;
          // Save silently
        },

        onResourceFieldCreateSave: function(e, data) {

        },

        onResourceFieldCreateCancel: function(e, data) {
          // TODO: Need to handle this
        }
      },

      error: {
        complete: function(response, status, headers, config) {
          // TODO: Need to handle this
        },
        onResourceFieldCreateSave: function(e, data) {
          // TODO: Need to handle this
        },
        onResourceFieldCreateCancel: function(e, data) {
          // TODO: Need to handle this
        }
      },

      // Listeners
      onResourceFieldCreateSave: function(e, data) {
        var s;

        // Save for callback function
        // This could break down if saveField is called consecutively before the callback fires
        //s = $scope.resourcesCreate.tmp.fields[data.index].stringArrayValue;

        // Convert string back into array because angular makes this an array via ng-model
        //$scope.resourcesCreate.tmp.fields[data.index].stringArrayValue = HelpersService.stringToArray(s);
        $scope.resourcesCreate.tmp.fields[data.index].fieldOrder = ($scope.resourcesCreate.model.fields instanceof Array) ? $scope.resourcesCreate.model.fields.length + 1 : 1;

        // Clear out the tmp field
        $scope.resourcesCreate.tmp.fields.splice(data.index, 1);
        if (($scope.resourcesCreate.model.fields instanceof Array) !== true) {
          $scope.resourcesCreate.model.fields = [];
        }
        // Update the fieldOrder for the new field
        data.field.fieldOrder = ($scope.resourcesCreate.model.fields instanceof Array) ? $scope.resourcesCreate.model.fields.length + 1 : 1;
        //data.field.stringArrayValue = HelpersService.stringToArray(s);

        // Add the field to the top of the list
        $scope.resourcesCreate.model.fields.unshift(data.field);
        $scope.resourcesCreate.addField();

      },

      onResourceFieldCreateCancel: function(e, data) {
        $scope.resourcesCreate.tmp.fields.splice(data.index, 1);
      },

      onResourceFieldDetailRemove: function(e, data) {
        var i, ii;

        $scope.resourcesCreate.model.fields.splice(data.index, 1);

        for (i=0,ii=$scope.resourcesCreate.model.fields.length;i<ii;i++) {
          $scope.resourcesCreate.model.fields[i].fieldOrder = (ii - i);
        }

      }

    };

    $scope.resourcesCreate.init();

}]);